module.exports = __webpack_public_path__ + "img/mobile-check.adc623e9.svg";